import { Ng2StateDeclaration, Transition } from "@uirouter/angular";
import { AuthorizenetCheckoutFeatureComponent } from "./authorizenet-checkout-feature/authorizenet-checkout-feature.component";

export const AuthorizeNetCheckoutRoute: Ng2StateDeclaration = {
    name: 'efaactstore',
    url: '/efaactstore',
    data: { requiresAuth: true },
    // resolve: [
    //     {
    //         token: 'transactionResponse',
    //         deps: [Transition],
    //         resolveFn: t => t.params()?.transactionResponse
    //     }
    // ],
    component: AuthorizenetCheckoutFeatureComponent
};
